import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "value" }

import { useAttrs } from "vue";
  import { format_currency } from "@/utils/currencies";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentBid',
  props: {
    currentBidProp: {}
  },
  setup(__props: any) {

  const attrs = useAttrs();

  const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(attrs).class)
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(trans)("live.catalog.lot_card.current_bid")), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format_currency)(props.currentBidProp)), 1)
  ], 2))
}
}

})